<script lang="ts">
  import { untrack } from 'svelte';
  import { createMutation, useQueryClient } from '@tanstack/svelte-query';
  import { projectsApi, type ProjectInput } from '$lib/api/projects';
  import { getErrorMessage } from '$lib/api/client';
  import type { Project } from '$lib/types';
  import Modal from '$lib/components/ui/Modal.svelte';

  const { project, onClose, onSaved }: { project?: Project; onClose: () => void; onSaved: (project: Project) => void } = $props();
  const client = useQueryClient();
  let name = $state(untrack(() => project?.name ?? ''));
  let customer = $state(untrack(() => project?.client_name ?? ''));
  let location = $state(untrack(() => project?.location ?? ''));
  const save = createMutation(() => ({
    mutationFn: (body: ProjectInput) => project ? projectsApi.update(project.id, body) : projectsApi.create(body),
    onSuccess: (saved) => {
      client.invalidateQueries({ queryKey: ['projects'] });
      onSaved(saved);
    }
  }));
</script>

<Modal title={project ? 'Edit project' : 'Create project'} {onClose}>
  <form class="flex flex-col gap-4" onsubmit={(e) => { e.preventDefault(); save.mutate({ name: name.trim(), client_name: customer.trim(), location: location.trim() }); }}>
    <label class="text-sm text-navy">Project name <input class="input w-full mt-1" bind:value={name} required /></label>
    <label class="text-sm text-navy">Customer (optional) <input class="input w-full mt-1" bind:value={customer} /></label>
    <label class="text-sm text-navy">Site / location (optional) <input class="input w-full mt-1" bind:value={location} /></label>
    <p class="text-xs text-dark-gray">Grouping only — does not change quotation details, pricing or export workflow.</p>
    {#if save.isError}<p class="tym-error-state">{getErrorMessage(save.error)}</p>{/if}
    <button type="submit" class="btn-primary self-end" disabled={!name.trim() || save.isPending}>{save.isPending ? 'Saving…' : 'Save project'}</button>
  </form>
</Modal>
